module.exports = __webpack_public_path__ + "static/media/launch_video.7ce883ca.mp4";